import { useStateValue } from "../../StateProvider";
import { isLiveApp } from "../../utils/Common";
import "./BottomNote.css";

const BottomNote = () => {
    const [{ apiHost, devApiHost }, dispatch] = useStateValue();

    return (
        <div className="app-page-note">
            <span>{isLiveApp() ? apiHost : devApiHost}</span>
        </div>
    );
};

export default BottomNote;
